import "./Drawing.css"
import Product1 from "../Components/Product1"

import Drawing1 from "../images/di1.jpg"
import Drawing2 from "../images/di2.jpg"
import Drawing3 from "../images/di3.jpg"
import Drawing4 from "../images/di4.jpg"
import Drawing5 from "../images/di5.jpg"
import Drawing6 from "../images/di6.jpg"
import Drawing7 from "../images/di7.jpg"
import Drawing8 from "../images/di8.jpg"
import Drawing9 from "../images/drawingadd.jpg"


export default function Drawing() {

  return (
    <div className="stdivinhome">
       <div className="add"><img src={Drawing9} /></div>
      <div className="home">

        <div className="home__prd">

          <div className="home__prd1">

            <Product1 id="draw1" prdName="SKETCH_PEN" img={Drawing1} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
              <Product1 id="draw2" prdName="BRUSHES" img={Drawing2} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>          

          </div>

          <div className="home__prd1">

          
          <Product1 id="draw3" prdName="SKETCHPEN_SET" img={Drawing3} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1 id="draw4" prdName="MARKERS" img={Drawing4} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
        

          </div>

        </div>


        <div className="home__prd">

          <div className="home__prd1">

            <Product1 id="draw5" prdName="SKETCHS_SET" img={Drawing5} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
            <Product1 id="draw6" prdName="PAINTING_COLOURS" img={Drawing6} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

          <div className="home__prd1">

            <Product1 id="draw7" prdName="COLOUR_PENCIL" img={Drawing7} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1 id="draw8" prdName="CRAYONS" img={Drawing8} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

        </div>

      </div>

    </div>
  )
}